import React from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../services/context";
import { baseURL } from "../services/axios/eps";
function LeaderBoard() {
  const { state } = useAppContext();
  const { dashboardData } = state;

  return (
    <>
      <div
        className="leaderboard-card col-lg-12 col-xxl-12"
        style={{
          backgroundColor: "#1a1f29",
          color: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div style={{ color: "white" }}>
          <div
            className="card-header align-items-center d-flex"
            style={{
              background: "linear-gradient(135deg, #4e73df, #1a1f29)",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
            }}
          >
            <div className="dropdown card-header-dropdown flex-shrink-0">
              <h6
                className="card-title mb-0 flex-grow-1"
                style={{ fontSize: "26px", margin: "10px 10px" }}
              >
                Leader Board
              </h6>
              <Link
                className="text-reset dropdown-btn"
                href="#"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ transition: "transform 0.3s ease" }}
              >
                <i
                  className="bi bi-three-dots-vertical"
                  style={{ fontSize: "1.5rem" }}
                />
              </Link>
            </div>
          </div>
          <div className="card-body" style={{ padding: "20px" }}>
            <div className="table-responsive">
              <table
                className="table table-borderless table-striped table-centered align-middle table-nowrap mb-0 table-dark"
                style={{
                  backgroundColor: "#121212",
                  color: "#ccc",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
              >
                <thead
                  className="bg-dark"
                  style={{
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                  }}
                >
                  <tr>
                    <th scope="col" className="text-light">
                      Rank
                    </th>
                    <th scope="col" className="text-light">
                      Name
                    </th>
                    <th scope="col" className="text-light">
                      Badge
                    </th>
                    <th scope="col" className="text-light">
                      Total Ads Watched
                    </th>
                    <th scope="col" className="text-light">
                      Score
                    </th>
                  </tr>
                </thead>
                <tbody className="list">
                  {dashboardData?.leaderborad_data?.map((user, i) => (
                    <tr style={{ borderBottom: "1px solid #333" }} key={i}>
                      <td className="text-light">{i + 1}</td>
                      <td className="name">
                        <Link className="fw-medium text-light id d-flex align-items-center gap-2">
                          {`${user?.watched_by_user?.first_name || ""} ${user?.watched_by_user?.last_name || ""}`}
                        </Link>
                      </td>
                      <td>
                        {user?.badges[0]?.icon ? (
                          <img
                            src={`${baseURL}/uploads/file/${user?.badges[0]?.icon}`}
                            alt="John Deo"
                            className="rounded-circle"
                            width="40"
                            height="40"
                            style={{
                              objectFit: "cover",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </td>
                      <td>{user?.total_watched_ads}</td>
                      <td>{user.contribution}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .leaderboard-card .table td,
        .leaderboard-card .table th {
          vertical-align: middle;
        }

        /* Hover effect for image */
        .leaderboard-card .table td img {
          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
        }

        .leaderboard-card .table td img:hover {
          transform: scale(1.1);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
        }

        /* Hover effect for table row */
        .leaderboard-card .table tr:nth-child(odd) {
          background-color: #222;
        }

        .leaderboard-card .table tr:hover {
          background-color: #333;
          transform: scale(1.02);
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2); /* Shadow effect */
        }

        .leaderboard-card .table tr:hover td {
          color: #ffcc00; /* Change text color on hover */
        }

        .leaderboard-card .dropdown-btn {
          transition: transform 0.3s ease;
        }

        .leaderboard-card .dropdown-btn:hover {
          transform: scale(1.1);
        }

        /* Add smooth transition for the text */
        .leaderboard-card .table td,
        .leaderboard-card .table th {
          transition: color 0.3s ease;
        }

        .card-header {
          padding: 20px;
        }

        .card-body {
          padding: 20px;
        }
      `}</style>
    </>
  );
}

export default LeaderBoard;
